<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>钻头列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div>
        <div class="filters">
          <span>筛选</span>
          <div class="filter">
            <el-select
              v-model="filter.status"
              placeholder="状态"
              size="small"
              style="margin: 0 10px; width: 120px"
            >
              <el-option :key="0" label="全部状态" :value="0"></el-option>
              <el-option :key="1" label="待生产" :value="1"></el-option>
              <el-option :key="2" label="生产中" :value="2"></el-option>
              <el-option :key="3" label="已完成" :value="3"></el-option>
              <el-option :key="5" label="已暂停" :value="5"></el-option>
              <el-option :key="4" label="已关闭" :value="4"></el-option>
            </el-select>
            <el-input
              placeholder="输入名称或序列号"
              v-model="filter.query"
              size="small"
              clearable
              style="margin: 0 10px; width: 200px"
            ></el-input>
            <el-button type="primary" size="small" @click="search"
              >搜索</el-button
            >
          </div>
        </div>
        <el-table :data="products" style="width: 100%" size="small">
          <el-table-column prop="name" label="产品名称"></el-table-column>
          <el-table-column
            prop="identifier"
            label="序列号"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <DrillLink :no="scope.row.identifier"></DrillLink></template
          ></el-table-column>
          <el-table-column
            prop="type"
            label="产品类型"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column label="生产状态" width="150" align="center">
            <template slot-scope="scope">
              {{ statusString(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                v-code="43101"
                v-if="scope.row.status == 0"
                type="primary"
                size="mini"
                plain
                @click="startFlow(scope.row, scope.$index)"
              >
                开始生产
              </el-button>

              <el-button
                v-else-if="scope.row.status != 0"
                type="text"
                size="mini"
                @click="$router.push('products/' + scope.row.identifier)"
              >
                生产详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          style="margin-top: 20px"
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="filter.page_size"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <flow-editor
      v-code="43101"
      :model="selectProduct"
      :show.sync="dialogVisible"
      @started="startedFlow"
    ></flow-editor>
  </div>
</template>

<script>
import { products } from '@/service/getData'
import flowEditor from '@/views/produce/flow/flow_editor'

export default {
  components: { flowEditor },
  data() {
    return {
      dialogVisible: false,
      products: [],
      selectProduct: {},
      selectIndex: -1,
      total: 0,
      filter: {
        page: 1,
        page_size: 20,
        status: 0,
        query: '',
      },
    }
  },
  created() {
    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      page_size: parseInt(this.$route.query.page_size || 20),
      status: parseInt(this.$route.query.status) || 0,
      query: this.$route.query.query || '',
    }
    this.initData()
  },
  methods: {
    search() {
      this.filter.page = 1
      this.initData()
    },
    async initData() {
      this.$router
        .replace({
          query: this.filter,
        })
        .catch((err) => {
          err
        })
      let data = {
        query: encodeURIComponent(this.filter.query),
        status: this.filter.status,
        page: this.filter.page - 1,
        page_size: this.filter.page_size,
      }
      let res = await products(data)
      this.products = res.data.list
      this.total = res.data.total
    },
    handleCurrentChange(e) {
      this.filter.page = e
      this.initData()
    },
    startFlow(product, index) {
      this.selectIndex = index
      this.dialogVisible = true
      this.selectProduct = {
        product_id: product.id,
        product_name: product.name,
        flow_template_id: '',
        product_size_name: '',
        name: product.name,
        inspector_id: '',
        inspector_name: '',
        fire_mode: 1,
      }
    },
    startedFlow() {
      if (this.selectIndex >= 0) {
        this.products[this.selectIndex].status = 1
        // this.products.splice(this.selectIndex, 1)
      }
      this.$message({
        showClose: false,
        duration: 1000,
        message: '生成流程已开始！',
        type: 'success',
      })
      this.selectIndex = -1
    },
    statusString(status) {
      if (status == 1) {
        return '生产中'
      } else if (status == 2) {
        return '已完成'
      } else if (status == 3) {
        return '已关闭'
      } else if (status == 4) {
        return '已暂停'
      } else {
        return '待生产'
      }
    },
  },
}
</script>

<style scoped>
.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.filter {
  display: flex;
  /* justify-content: space-between; */
  /* align-items: center; */
}
.actions span {
  display: inline-block;
  margin-right: 1em;
  cursor: pointer;
}
</style>